export class CapturePricingCardCommand {
	superhogUserId: string | null;
	productId: number;
	currencyId: number;
	pricingCardTypeId: number;
	petProtectionScopeId?: number;
	amount: number;
	startDate?: string;
}
